import { render, staticRenderFns } from "./BookingChecklist.vue?vue&type=template&id=3639a1c0&scoped=true"
import script from "./BookingChecklist.vue?vue&type=script&lang=js"
export * from "./BookingChecklist.vue?vue&type=script&lang=js"
import style0 from "./BookingChecklist.vue?vue&type=style&index=0&id=3639a1c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3639a1c0",
  null
  
)

export default component.exports